export default "__VITE_ASSET__QiXkGPb1__"